// import React, { useState, useEffect, useCallback } from "react";
// import { Plus, Search, Edit2, Trash2, Library, Layers, Filter, X, Eye, Shield } from "lucide-react";
// import { toast } from "react-toastify";

// // Form Views imports
// import SummaryApi from "../../common/SummaryApi";
// import api from "../../common/apiClient";
// import PageLoader from "../../helpers/PageLoader";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import ModernTable from "../ui/ModernTable";
// import IndividualKraForm from "./IndividualKraForm";
// import BundleKraForm from "./BundleKraForm";
// import PageHeader from "../../components/ui/PageHeader";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import DeleteConfirmationOffcanvas from "../../helpers/DeleteConfirmationOffcanvas";


// // ==========================================
// // 1. READ-ONLY VIEW: Individual KRA View
// // ==========================================
// const IndividualKraView = ({ kra, onClose, onBackToWizard, onEdit }) => {
//   const getOrgName = (field) => {
//     if (!field) return "N/A";
//     return typeof field === 'object' ? field.name : field;
//   };

//   return (
//     <div className="space-y-6 p-2 animate-in fade-in duration-300">
//       {/* Breadcrumbs */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
//         <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
//           <button type="button" onClick={onClose} className="hover:text-secondary transition-colors focus:outline-none">
//             KRA Library
//           </button>
//           <span className="text-gray-300">&gt;</span>
//           <button onClick={onBackToWizard || onClose} className="hover:text-secondary transition-colors focus:outline-none">Individual KRA</button>
//           <span className="text-gray-300">&gt;</span>
//           <span className="text-secondary font-bold">View Details</span>
//         </nav>

//         <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
//           Individual KRA
//         </div>
//       </div>

//       <div className="bg-white rounded-xl p-4 space-y-6">
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b pb-4">
//           <div className="flex items-center gap-3">
//             <span className="p-2.5 bg-red-50 text-primary rounded-md"><Shield className="w-5 h-5" /></span>
//             <div>
//               <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">{kra?.kraId || "KRA-TMP"}</p>
//               <h3 className="text-lg font-bold text-gray-900 leading-tight mt-0.5">{kra?.name}</h3>
//             </div>
//           </div>
//           <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${kra?.status === "ACTIVE" ? "bg-green-100 text-green-700 border border-green-200" : "bg-gray-100 text-gray-500 border border-gray-200"}`}>
//             {kra?.status || "DRAFT"}
//           </span>
//         </div>

//         {/* Info Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//           <div className="md:col-span-2 space-y-5">
//             <div>
//               <h4 className="text-xs font-bold text-gray-400 uppercase">Description</h4>
//               <p className="text-sm text-gray-700 mt-1.5 leading-relaxed bg-gray-50/50 p-4 rounded-lg border border-gray-100">{kra?.description}</p>
//             </div>
            
//             {kra?.remarks && (
//               <div>
//                 <h4 className="text-xs font-bold text-gray-400 uppercase">Remarks / Internal Notes</h4>
//                 <p className="text-xs text-gray-500 mt-1.5 leading-relaxed italic bg-gray-50 p-3 rounded-lg border border-dashed">{kra?.remarks}</p>
//               </div>
//             )}
//           </div>

//           <div className="space-y-5 bg-gray-50/30 p-5 rounded-lg border border-gray-100">
//             <div>
//               <h4 className="text-[10px] font-bold text-gray-400 uppercase">Category</h4>
//               <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-2 rounded-lg mt-1.5">{kra?.category || "Technical"}</p>
//             </div>
//             <div>
//               <h4 className="text-[10px] font-bold text-gray-400 uppercase">Review Frequency</h4>
//               <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-2 rounded-lg mt-1.5">
//                 {kra?.reviewCycle === "1_MONTH" ? "Monthly" : kra?.reviewCycle === "3_MONTHS" ? "Quarterly" : kra?.reviewCycle === "6_MONTHS" ? "Half-Yearly" : "Annual"}
//               </p>
//             </div>
//             {/* Template targets display added */}
//             <div>
//               <h4 className="text-[10px] font-bold text-gray-400 uppercase">Monthly Target</h4>
//               <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-2 rounded-lg mt-1.5">{kra?.monthlyTarget || "N/A"}</p>
//             </div>
//             <div>
//               <h4 className="text-[10px] font-bold text-gray-400 uppercase">Yearly Target</h4>
//               <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-2 rounded-lg mt-1.5">{kra?.yearlyTarget || "N/A"}</p>
//             </div>
//           </div>
//         </div>

//         {/* Org Structure Mapping */}
//         <div className="border-t pt-5 space-y-4">
//           <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider">Organizational Scope</h4>
//           <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//             <div className="bg-white border p-4 rounded-lg">
//               <p className="text-[10px] text-gray-400 font-bold uppercase">Division</p>
//               <p className="text-sm font-extrabold text-gray-800 mt-1">{getOrgName(kra?.divisionId)}</p>
//             </div>
//             <div className="bg-white border p-4 rounded-lg">
//               <p className="text-[10px] text-gray-400 font-bold uppercase">Department</p>
//               <p className="text-sm font-extrabold text-gray-800 mt-1">{getOrgName(kra?.departmentId)}</p>
//             </div>
//             <div className="bg-white border p-4 rounded-lg">
//               <p className="text-[10px] text-gray-400 font-bold uppercase">Designation</p>
//               <p className="text-sm font-extrabold text-gray-800 mt-1">{getOrgName(kra?.designationId)}</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer view actions */}
//       <div className="flex justify-between items-center">
//         <button onClick={onClose} className="px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase">
//           Back to Library
//         </button>
//         <button onClick={onEdit} className="px-6 py-2.5 bg-primary text-white hover:bg-secondary font-bold rounded-lg text-xs uppercase transition-all">
//           Edit KRA Details
//         </button>
//       </div>
//     </div>
//   );
// };

// // ==========================================
// // 2. READ-ONLY VIEW: Bundle KRA View
// // ==========================================
// const BundleKraView = ({ bundle, onClose, onBackToWizard, onEdit }) => {
//   const getOrgName = (field) => {
//     if (!field) return "N/A";
//     return typeof field === 'object' ? field.name : field;
//   };

//   return (
//     <div className="space-y-6 p-2 animate-in fade-in duration-300">
//       {/* Breadcrumbs */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
//         <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
//           <button type="button" onClick={onClose} className="hover:text-secondary transition-colors focus:outline-none">
//             KRA Library
//           </button>
//           <span className="text-gray-300">&gt;</span>
//           <button onClick={onBackToWizard || onClose} className="hover:text-secondary transition-colors focus:outline-none">Bundle KRA</button>
//           <span className="text-gray-300">&gt;</span>
//           <span className="text-secondary font-bold">View Details</span>
//         </nav>

//         <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
//           Bundle KRA
//         </div>
//       </div>
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Left column: Bundle General Info */}
//         <div className="lg:col-span-1 space-y-6">
//           <div className="bg-white rounded-xl p-4 space-y-5">
//             <div className="flex justify-between items-start gap-4">
//               <span className="p-2.5 bg-red-100 text-primary rounded-md"><Library className="w-5 h-5" /></span>
//               <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${bundle?.status === "ACTIVE" ? "bg-green-100 text-green-700 border border-green-200" : "bg-gray-100 text-gray-500 border border-gray-200"}`}>
//                 {bundle?.status || "DRAFT"}
//               </span>
//             </div>

//             <div>
//               <p className="text-[10px] text-gray-400 font-bold uppercase">Target Financial Year: {bundle?.year || "N/A"}</p>
//               <h3 className="text-lg font-bold text-gray-900 leading-tight mt-1">{bundle?.name}</h3>
//               <p className="text-xs text-gray-500 mt-2 leading-relaxed bg-gray-50 p-4 rounded-lg border">{bundle?.description || "No description provided."}</p>
//             </div>

//             <div className="border-t pt-4 space-y-3">
//               <div className="flex justify-between items-center text-xs">
//                 <span className="text-gray-400 font-bold uppercase text-[10px]">Review Cycle:</span>
//                 <span className="font-extrabold text-gray-800">
//                   {bundle?.reviewCycle === "1_MONTH" ? "Monthly" : bundle?.reviewCycle === "3_MONTHS" ? "Quarterly" : bundle?.reviewCycle === "6_MONTHS" ? "Half-Yearly" : "Annual"}
//                 </span>
//               </div>
//               <div className="flex justify-between items-center text-xs">
//                 <span className="text-gray-400 font-bold uppercase text-[10px]">Division:</span>
//                 <span className="font-extrabold text-gray-800 truncate max-w-[150px]">{getOrgName(bundle?.divisionId)}</span>
//               </div>
//               <div className="flex justify-between items-center text-xs">
//                 <span className="text-gray-400 font-bold uppercase text-[10px]">Department:</span>
//                 <span className="font-extrabold text-gray-800 truncate max-w-[150px]">{getOrgName(bundle?.departmentId)}</span>
//               </div>
//               <div className="flex justify-between items-center text-xs">
//                 <span className="text-gray-400 font-bold uppercase text-[10px]">Designation:</span>
//                 <span className="font-extrabold text-gray-800 truncate max-w-[150px]">{getOrgName(bundle?.designationId)}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right column: Linked KRAs and Weightage Details */}
//         <div className="lg:col-span-2 space-y-4">
//           <div className="bg-white rounded-xl p-4 space-y-4">
//             <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wider border-b pb-2">Linked Goal Metrics & Weightage</h4>
            
//             <div className="space-y-4">
//               {bundle?.kras?.map((k, idx) => (
//                 <div key={idx} className="bg-gray-50/50 border border-gray-100 rounded-lg p-4 space-y-3 hover:shadow-[0_0_25px_rgba(239,68,68,0.2)] transition-all duration-300">
//                   <div className="flex justify-between items-start gap-4">
//                     <div className="min-w-0 flex-1">
//                       <div className="flex items-center gap-2">
//                         <span className="flex h-5 w-5 items-center justify-center rounded bg-gray-200 text-gray-500 font-bold text-[9px]">
//                           {String(idx + 1).padStart(2, "0")}
//                         </span>
//                         <p className="text-xs font-bold text-gray-800 truncate">{k.kraId?.name || k.name || "Custom KRA"}</p>
//                       </div>
//                       <p className="text-[11px] text-gray-400 leading-relaxed mt-1">{k.kraId?.description || k.description}</p>
                      
//                       {/* Individual Target View in Bundle list */}
//                       <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-3 pt-2 border-t border-gray-100 text-[11px]">
//                         <div>
//                           <span className="text-gray-400 font-bold uppercase text-[8px] block">Review Cycle</span>
//                           <span className="text-gray-700 font-semibold">
//                             {k.reviewCycle === "1_MONTH" ? "Monthly" : k.reviewCycle === "3_MONTHS" ? "Quarterly" : k.reviewCycle === "6_MONTHS" ? "Half-Yearly" : "Annual"}
//                           </span>
//                         </div>
//                         <div>
//                           <span className="text-gray-400 font-bold uppercase text-[8px] block">Monthly Target</span>
//                           <span className="text-gray-700 font-semibold">{k.monthlyTarget || "N/A"}</span>
//                         </div>
//                         <div>
//                           <span className="text-gray-400 font-bold uppercase text-[8px] block">Yearly Target</span>
//                           <span className="text-gray-700 font-semibold">{k.yearlyTarget || "N/A"}</span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="shrink-0 text-right">
//                       <p className="text-xs font-bold text-primary">{k.weightage || 0}%</p>
//                       <p className="text-[8px] text-gray-400 font-bold uppercase">Weight</p>
//                     </div>
//                   </div>

//                   {/* Weight Progress visualization bar */}
//                   <div className="w-full bg-gray-200 h-1.5 rounded-full overflow-hidden">
//                     <div className="bg-primary h-full rounded-full" style={{ width: `${k.weightage || 0}%` }} />
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer view actions */}
//       <div className="flex justify-between items-center">
//         <button onClick={onClose} className="px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase">
//           Back to Library
//         </button>
//         <button onClick={onEdit} className="px-4 py-2.5 bg-primary text-white hover:bg-secondary font-bold rounded-lg text-xs uppercase transition-all">
//           Edit Bundle Details
//         </button>
//       </div>
//     </div>
//   );
// };


// // ==========================================
// // MAIN COMPONENT: KraLibrary
// // ==========================================
// export default function KraLibrary() {
//   const navigate = useNavigate();
  
//   const [searchParams, setSearchParams] = useSearchParams();
//   const view = searchParams.get("libView") || "list"; 
//   const selectedId = searchParams.get("id"); 

//   const [subTab, setSubTab] = useState("individual"); 
//   const [loading, setLoading] = useState(true);
//   const [selectedItem, setSelectedItem] = useState(null); 

//   const [templates, setTemplates] = useState([]);
//   const [bundles, setBundles] = useState([]);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [showFilters, setShowFilters] = useState(false);
//   const [categoryFilter, setCategoryFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   // ✅ 2. Offcanvas க்கான பிரத்யேக ஸ்டேட்கள் (State handlers for Offcanvas)
//   const [isDeleteOpen, setIsDeleteOpen] = useState(false);
//   const [itemToDelete, setItemToDelete] = useState(null);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [deleteError, setDeleteError] = useState(null);

//   const prefetchLibraryData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const cacheBuster = Date.now();
//       const [templatesRes, bundlesRes] = await Promise.all([
//         api.get(`${SummaryApi.getAllKraTemplates?.url || "/api/hr/kras/templates"}?t=${cacheBuster}`),
//         api.get(`${SummaryApi.getAllKraBundles?.url || "/api/hr/kras/bundles"}?t=${cacheBuster}`)
//       ]);

//       if (templatesRes.data.success) setTemplates(templatesRes.data.data || []);
//       if (bundlesRes.data.success) setBundles(bundlesRes.data.data || []);
//     } catch {
//       toast.error("Failed to load KRA Library assets.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     prefetchLibraryData();
//   }, [prefetchLibraryData]);

//   useEffect(() => {
//     if (selectedId && (templates.length > 0 || bundles.length > 0)) {
//       const isBundleView = view.includes("bundle");
//       const activeDataset = isBundleView ? bundles : templates;
//       const item = activeDataset.find(t => t._id === selectedId);
//       if (item) {
//         setSelectedItem(item);
//         setSubTab(isBundleView ? "bundles" : "individual"); 
//       }
//     } else if (!selectedId) {
//       setSelectedItem(null);
//     }
//   }, [selectedId, templates, bundles, view]);

//   const setView = useCallback((newView) => {
//     const params = new URLSearchParams(searchParams);
//     if (newView === "list") {
//       params.delete("libView");
//       params.delete("id");
//     } else {
//       params.set("libView", newView);
//       if (!newView.startsWith("edit_") && !newView.startsWith("view_")) {
//         params.delete("id");
//       }
//     }
//     setSearchParams(params, { replace: true });
//   }, [searchParams, setSearchParams]);

//   const handleSave = () => {
//     setView("list");
//     prefetchLibraryData();
//   };

//   const filteredData = React.useMemo(() => {
//     const activeDataset = subTab === "individual" ? templates : bundles;
//     return activeDataset.filter(item => {
//       if (searchTerm) {
//         const searchLower = searchTerm.toLowerCase();
//         if (!item.name?.toLowerCase().includes(searchLower) && !item.kraId?.toLowerCase().includes(searchLower)) return false;
//       }
//       if (subTab === "individual" && categoryFilter && item.category !== categoryFilter) return false;
//       if (statusFilter && item.status !== (statusFilter === "active" ? "ACTIVE" : "DRAFT")) return false;
//       return true;
//     });
//   }, [subTab, templates, bundles, searchTerm, categoryFilter, statusFilter]);

//   const paginatedData = React.useMemo(() => {
//     if (itemsPerPage === "All") return filteredData;
//     const start = (currentPage - 1) * Number(itemsPerPage);
//     return filteredData.slice(start, start + Number(itemsPerPage));
//   }, [filteredData, currentPage, itemsPerPage]);

//   const handleEdit = (row) => {
//     setSelectedItem(row);
//     const params = new URLSearchParams(searchParams);
//     params.set("libView", subTab === "individual" ? "edit_individual" : "edit_bundle");
//     params.set("id", row._id);
//     setSearchParams(params, { replace: true });
//   };

//   const handleView = (row) => {
//     setSelectedItem(row);
//     const params = new URLSearchParams(searchParams);
//     params.set("libView", subTab === "individual" ? "view_individual" : "view_bundle");
//     params.set("id", row._id);
//     setSearchParams(params, { replace: true });
//   };

//   // ✅ 3. எளிய window.confirm-க்கு பதிலாக Offcanvas-ஐ ஓப்பன் செய்யும்படி மாற்றப்பட்டுள்ளது
//   const handleDeleteClick = (row) => {
//     setItemToDelete(row);
//     setDeleteError(null);
//     setIsDeleteOpen(true);
//   };

//   // ✅ 4. Offcanvas-க்குள் Confirm பட்டனை அழுத்தும்போது இயங்கும் செயல்பாடு (API Integration)
//   const handleConfirmDelete = async () => {
//     if (!itemToDelete) return;
//     setIsDeleting(true);
//     setDeleteError(null);
//     try {
//       const endpoint = subTab === "individual"
//         ? SummaryApi.deleteKraTemplate?.url(itemToDelete._id)
//         : SummaryApi.deleteKraBundle?.url(itemToDelete._id);

//       await api.delete(endpoint);
//       toast.success("Successfully deleted item.");
      
//       if (subTab === "individual") {
//         setTemplates(p => p.filter(t => t._id !== itemToDelete._id));
//       } else {
//         setBundles(p => p.filter(b => b._id !== itemToDelete._id));
//       }
//       setIsDeleteOpen(false);
//       setItemToDelete(null);
//     } catch (err) {
//       // பேக்-எண்ட் பிழைகளைச் (Linked/Assigned error) சரியாகத் திரையில் காட்டுகிறது
//       const errMsg = err.response?.data?.message || "Deletion failed.";
//       setDeleteError({ message: errMsg, users: [] });
//       toast.error(errMsg);
//     } finally {
//       setIsDeleting(false);
//     }
//   };

//   const tableActions = [
//     { label: "View Details", icon: <Eye className="h-4 w-4" />, onClick: (row) => handleView(row) },
//     { label: "Edit Item", icon: <Edit2 className="h-4 w-4" />, onClick: (row) => handleEdit(row) },
//     { label: "Delete Item", icon: <Trash2 className="h-4 w-4" />, onClick: (row) => handleDeleteClick(row) } // Changed to click handler
//   ];

//   if (view === "create_wizard") {
//     return (
//       <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 text-center space-y-8 animate-in fade-in duration-300">
//         <div className="flex justify-between items-center border-b pb-4">
//           <h3 className="font-bold text-gray-900 text-lg md:text-2xl">Choose Creation Type</h3>
//           <button onClick={() => setView("list")} className="text-gray-400 hover:text-primary transition-transform duration-300 hover:rotate-180 font-bold"><X/></button>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4">
//           <div className="bg-white border-2 border-gray-100 hover:border-primary rounded-lg p-8 text-center flex flex-col justify-between items-center transition-all hover:shadow-lg group">
//             <div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center mb-6 text-primary transition-all group-hover:bg-red-100"><Library className="w-8 h-8" /></div>
//             <h3 className="text-lg font-bold text-gray-900 mb-2">Individual KRA</h3>
//             <p className="text-xs text-gray-400 max-w-xs mb-6">Create one KRA for future allocation. Best for specific, unique performance metrics.</p>
//             <button onClick={() => { setSelectedItem(null); setView("create_individual"); }} className="bg-primary hover:bg-secondary text-white font-bold text-sm px-8 py-2.5 rounded-lg transition-all">Select</button>
//           </div>
//           <div className="bg-white border-2 border-gray-100 hover:border-primary rounded-lg p-8 text-center flex flex-col justify-between items-center transition-all hover:shadow-lg group">
//             <div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center mb-6 text-primary transition-all group-hover:bg-red-100"><Layers className="w-8 h-8" /></div>
//             <h3 className="text-lg font-bold text-gray-900 mb-2">Bundle KRA</h3>
//             <p className="text-xs text-gray-400 max-w-xs mb-6">Create multiple KRAs together as one reusable bundle. Perfect for standardized roles.</p>
//             <button onClick={() => { setSelectedItem(null); setView("create_bundle"); }} className="bg-primary hover:bg-secondary text-white font-bold text-sm px-8 py-2.5 rounded-lg transition-all">Select</button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (view === "create_individual" || view === "edit_individual") {
//     return (
//       <IndividualKraForm 
//         kra={selectedItem} 
//         kraId={selectedId}
//         onClose={() => setView("list")} 
//         onSave={handleSave} 
//         onBackToWizard={() => setView("create_wizard")}
//       />
//     );
//   }

//   if (view === "create_bundle" || view === "edit_bundle") {
//     return (
//       <BundleKraForm 
//         bundle={selectedItem} 
//         bundleId={selectedId}
//         onClose={() => setView("list")} 
//         onSave={handleSave} 
//         onBackToWizard={() => setView("create_wizard")}
//       />
//     );
//   }

//   if (view === "view_individual") {
//     return (
//       <IndividualKraView 
//         kra={selectedItem} 
//         onClose={() => setView("list")} 
//         onEdit={() => setView("edit_individual")}
//         onBackToWizard={() => setView("create_wizard")} 
//       />
//     );
//   }

//   if (view === "view_bundle") {
//     return (
//       <BundleKraView 
//         bundle={selectedItem} 
//         onClose={() => setView("list")} 
//         onEdit={() => setView("edit_bundle")} 
//         onBackToWizard={() => setView("create_wizard")}
//       />
//     );
//   }

//   return (
//     <div className="">
//     <div className="space-y-6">
//       <PageHeader
//         title="Key Result Areas"
//         description="Manage and allocate organization-wide performance benchmarks."
//         isSticky={true}
//         topOffset="top-[51px]"
//         onBack={() => navigate(-1)}
//         action={{
//           label: "Create New KRA",
//           icon: Plus,
//           onClick: () => setView("create_wizard"),
//         }}
//       />

//       {/* Tabs updated with dynamic length counts */}
//       <div className="flex gap-2 pb-px">
//         <button onClick={() => { setSubTab("individual"); setCurrentPage(1); }} className={`pb-2.5 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${subTab === "individual" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"}`}>
//           Individual Templates ({templates.length})
//         </button>
//         <button onClick={() => { setSubTab("bundles"); setCurrentPage(1); }} className={`pb-2.5 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${subTab === "bundles" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"}`}>
//           KRA Bundles ({bundles.length})
//         </button>
//       </div>

//       <div className="space-y-4">
//         <div className="flex flex-col sm:flex-row gap-4">
//           <div className="relative flex-1">
//             <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//             <input type="text" placeholder={`Search ${subTab === "individual" ? "individual templates" : "KRA bundles"}...`} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 outline-none text-sm" />
//           </div>
//           <button onClick={() => setShowFilters(!showFilters)} className={`flex items-center gap-2 px-4 py-2 border rounded-lg text-sm transition-colors ${showFilters ? 'bg-red-50 border-red-300 text-red-700 font-semibold' : 'bg-white border-gray-300'}`}>
//             <Filter className="h-5 w-5" /> Filters
//           </button>
//         </div>

//         {showFilters && (
//           <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 animate-in fade-in slide-in-from-top-2">
//             <SelectDropdown label="Status" options={[{ label: 'All Status', value: '' }, { label: 'Active', value: 'active' }, { label: 'Draft', value: 'inactive' }]} value={statusFilter} onChange={setStatusFilter} valueKey="value" labelKey="label" searchable={true} />
//             <button onClick={() => { setCategoryFilter(''); setStatusFilter(''); setSearchTerm(''); }} className="text-primary text-sm font-medium flex items-center gap-1 hover:underline">
//               <X className="h-4 w-4" /> Clear All Filters
//             </button>
//           </div>
//         )}
//       </div>

//       {loading ? (
//         <PageLoader />
//       ) : filteredData.length === 0 ? (
//         <div className="bg-white rounded-xl border p-12 text-center mt-4">
//           <Library className="h-12 w-12 text-gray-300 mx-auto mb-4" />
//           <h3 className="text-lg font-medium text-gray-900">No records found</h3>
//           <p className="text-gray-500">Try adjusting your filters or search keywords.</p>
//         </div>
//       ) : (
//         <ModernTable
//           columns={subTab === "individual" ? [
//             { label: "KRA Code", key: "kraId", render: (row) => <span className="font-mono font-bold text-gray-500">{row.kraId || "KRA-TMP"}</span> },
//             { label: "Goal Benchmark Details", key: "name", render: (row) => <div><p className="font-bold text-gray-900">{row.name}</p><p className="text-[11px] text-gray-400 truncate max-w-xs">{row.description}</p></div> },
//             { label: "Category", key: "category", render: (row) => <span className="bg-red-50 text-primary border border-red-100 px-2.5 py-0.5 rounded-full font-bold text-[10px] uppercase">{row.category || "General"}</span> },
//             { label: "Review Cycle", key: "reviewCycle", render: (row) => <span className="font-medium text-gray-600">{row.reviewCycle}</span> },
//             { label: "Status", key: "status", render: (row) => <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${row.status === "ACTIVE" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>{row.status || "DRAFT"}</span> }
//           ] : [
//             { label: "Target Year", key: "year", render: (row) => <span className="font-mono font-bold text-gray-500">{row.year}</span> },
//             { label: "Bundle Configuration Name", key: "name", render: (row) => <div><p className="font-bold text-gray-900">{row.name}</p><p className="text-[11px] text-gray-400 truncate max-w-xs">{row.description}</p></div> },
//             { label: "Total Goals Linked", key: "kras", render: (row) => <span className="font-bold text-gray-700">{row.kras?.length || 0} items</span> },
//             { label: "Review Cycle", key: "reviewCycle", render: (row) => <span className="font-medium text-gray-600">{row.reviewCycle}</span> },
//             { label: "Status", key: "status", render: (row) => <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${row.status === "ACTIVE" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>{row.status || "DRAFT"}</span> }
//           ]}
//           data={paginatedData}
//           actions={tableActions}
//           selectable={false}
//           stickyColumns={1}
//           pagination={{
//             totalItems: filteredData.length,
//             itemsPerPage: itemsPerPage,
//             currentPage: currentPage,
//             onPageChange: setCurrentPage,
//             onItemsPerPageChange: (val) => { setItemsPerPage(val); setCurrentPage(1); }
//           }}
//         />
//       )}

//     </div>
//       {/* ✅ 5. Offcanvas கூறு இங்கு பொருத்தப்பட்டுள்ளது (Integrated delete offcanvas UI) */}
//       <DeleteConfirmationOffcanvas
//         isOpen={isDeleteOpen}
//         onClose={() => {
//           setIsDeleteOpen(false);
//           setItemToDelete(null);
//           setDeleteError(null);
//         }}
//         onConfirm={handleConfirmDelete}
//         title={subTab === "individual" ? "Delete KRA Template" : "Delete KRA Bundle"}
//         itemName={itemToDelete?.name || ""}
//         error={deleteError}
//         isLoading={isDeleting}
//         deleteType="hard"
//         navigateButtonText="Dismiss"
//         onNavigateToUsers={() => {
//           setIsDeleteOpen(false);
//           setItemToDelete(null);
//           setDeleteError(null);
//         }}
//         onViewUser={() => {}}
//       />
//     </div>
//   );
// }


import React, { useState, useEffect, useCallback } from "react";
import { Plus, Search, Edit2, Trash2, Library, Layers, Filter, X, Eye, Shield } from "lucide-react";
import { toast } from "react-toastify";

import SummaryApi from "../../common/SummaryApi";
import api from "../../common/apiClient";
import PageLoader from "../../helpers/PageLoader";
import SelectDropdown from "../../customStyles/SelectDropdown";
import ModernTable from "../ui/ModernTable";
import IndividualKraForm from "./IndividualKraForm";
import BundleKraForm from "./BundleKraForm";
import PageHeader from "../../components/ui/PageHeader";
import { useNavigate, useSearchParams } from "react-router-dom";
import DeleteConfirmationOffcanvas from "../../helpers/DeleteConfirmationOffcanvas";

// Helper function to format system DB cycle keys to human readable text
const formatCycleDisplay = (cycle) => {
  const mapping = {
    "1_WEEK": "Weekly",
    "2_WEEKS": "Bi-weekly",
    "1_MONTH": "Monthly",
    "2_MONTHS": "Bi-monthly",
    "3_MONTHS": "Quarterly",
    "6_MONTHS": "Half-Yearly",
    "12_MONTHS": "Annual"
  };
  return mapping[cycle] || cycle;
};

// ==========================================
// 1. READ-ONLY VIEW: Individual KRA View
// ==========================================
const IndividualKraView = ({ kra, onClose, onBackToWizard, onEdit }) => {
  const getOrgName = (field) => {
    if (!field) return "N/A";
    return typeof field === 'object' ? field.name : field;
  };

  return (
    <div className="space-y-6 p-2 animate-in fade-in duration-300">
      {/* Breadcrumbs */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
          <button type="button" onClick={onClose} className="hover:text-secondary transition-colors focus:outline-none">
            KRA Library
          </button>
          <span className="text-gray-300">&gt;</span>
          <button onClick={onBackToWizard || onClose} className="hover:text-secondary transition-colors focus:outline-none">Individual KRA</button>
          <span className="text-gray-300">&gt;</span>
          <span className="text-secondary font-bold">View Details</span>
        </nav>

        <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
          Individual KRA
        </div>
      </div>

      <div className="bg-white rounded-xl p-4 space-y-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b pb-4">
          <div className="flex items-center gap-3">
            <span className="p-2.5 bg-red-50 text-primary rounded-md"><Shield className="w-5 h-5" /></span>
            <div>
              <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">{kra?.kraId || "KRA-TMP"}</p>
              <h3 className="text-lg font-bold text-gray-900 leading-tight mt-0.5">{kra?.name}</h3>
            </div>
          </div>
          <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${kra?.status === "ACTIVE" ? "bg-green-100 text-green-700 border border-green-200" : "bg-gray-100 text-gray-500 border border-gray-200"}`}>
            {kra?.status || "DRAFT"}
          </span>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 space-y-5">
            <div>
              <h4 className="text-xs font-bold text-gray-400 uppercase">Description</h4>
              <p className="text-sm text-gray-700 mt-1.5 leading-relaxed bg-gray-50/50 p-4 rounded-lg border border-gray-100">{kra?.description}</p>
            </div>
            
            {kra?.remarks && (
              <div>
                <h4 className="text-xs font-bold text-gray-400 uppercase">Remarks / Internal Notes</h4>
                <p className="text-xs text-gray-500 mt-1.5 leading-relaxed italic bg-gray-50 p-3 rounded-lg border border-dashed">{kra?.remarks}</p>
              </div>
            )}
          </div>

          <div className="space-y-4 bg-gray-50/30 p-5 rounded-lg border border-gray-100">
            <div>
              <h4 className="text-[10px] font-bold text-gray-400 uppercase">Category</h4>
              <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-2 rounded-lg mt-1">{kra?.category || "Technical"}</p>
            </div>
            <div>
              <h4 className="text-[10px] font-bold text-gray-400 uppercase">Review Frequency</h4>
              <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-2 rounded-lg mt-1">
                {formatCycleDisplay(kra?.reviewCycle)}
              </p>
            </div>
            {/* Added Target Value Display */}
            <div className="bg-red-50/50 p-3 rounded-lg border border-red-100">
              <h4 className="text-[10px] font-bold text-primary uppercase">Target Value</h4>
              <p className="text-xs font-black text-gray-800 bg-white border border-red-200 px-3 py-2 rounded-lg mt-1">{kra?.targetValue || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-[10px] font-bold text-gray-400 uppercase">Monthly Target (Legacy)</h4>
              <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-1.5 rounded-lg mt-1">{kra?.monthlyTarget || "N/A"}</p>
            </div>
            <div>
              <h4 className="text-[10px] font-bold text-gray-400 uppercase">Yearly Target (Legacy)</h4>
              <p className="text-xs font-extrabold text-gray-800 bg-white border px-3 py-1.5 rounded-lg mt-1">{kra?.yearlyTarget || "N/A"}</p>
            </div>
          </div>
        </div>

        {/* Org Structure Mapping */}
        <div className="border-t pt-5 space-y-4">
          <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider">Organizational Scope</h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white border p-4 rounded-lg">
              <p className="text-[10px] text-gray-400 font-bold uppercase">Division</p>
              <p className="text-sm font-extrabold text-gray-800 mt-1">{getOrgName(kra?.divisionId)}</p>
            </div>
            <div className="bg-white border p-4 rounded-lg">
              <p className="text-[10px] text-gray-400 font-bold uppercase">Department</p>
              <p className="text-sm font-extrabold text-gray-800 mt-1">{getOrgName(kra?.departmentId)}</p>
            </div>
            <div className="bg-white border p-4 rounded-lg">
              <p className="text-[10px] text-gray-400 font-bold uppercase">Designation</p>
              <p className="text-sm font-extrabold text-gray-800 mt-1">{getOrgName(kra?.designationId)}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer view actions */}
      <div className="flex justify-between items-center">
        <button onClick={onClose} className="px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase">
          Back to Library
        </button>
        <button onClick={onEdit} className="px-6 py-2.5 bg-primary text-white hover:bg-secondary font-bold rounded-lg text-xs uppercase transition-all">
          Edit KRA Details
        </button>
      </div>
    </div>
  );
};

// ==========================================
// 2. READ-ONLY VIEW: Bundle KRA View
// ==========================================
const BundleKraView = ({ bundle, onClose, onBackToWizard, onEdit }) => {
  const getOrgName = (field) => {
    if (!field) return "N/A";
    return typeof field === 'object' ? field.name : field;
  };

  return (
    <div className="space-y-6 p-2 animate-in fade-in duration-300">
      {/* Breadcrumbs */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <nav className="text-xs md:text-sm text-primary font-medium flex items-center gap-1.5 flex-wrap" aria-label="Breadcrumb">
          <button type="button" onClick={onClose} className="hover:text-secondary transition-colors focus:outline-none">
            KRA Library
          </button>
          <span className="text-gray-300">&gt;</span>
          <button onClick={onBackToWizard || onClose} className="hover:text-secondary transition-colors focus:outline-none">Bundle KRA</button>
          <span className="text-gray-300">&gt;</span>
          <span className="text-secondary font-bold">View Details</span>
        </nav>

        <div className="text-lg md:text-2xl font-bold text-gray-900 tracking-tight">
          Bundle KRA
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left column: Bundle General Info */}
        <div className="lg:col-span-1 space-y-6">
          <div className="bg-white rounded-xl p-4 space-y-5">
            <div className="flex justify-between items-start gap-4">
              <span className="p-2.5 bg-red-100 text-primary rounded-md"><Library className="w-5 h-5" /></span>
              <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${bundle?.status === "ACTIVE" ? "bg-green-100 text-green-700 border border-green-200" : "bg-gray-100 text-gray-500 border border-gray-200"}`}>
                {bundle?.status || "DRAFT"}
              </span>
            </div>

            <div>
              <p className="text-[10px] text-gray-400 font-bold uppercase">Target Financial Year: {bundle?.year || "N/A"}</p>
              <h3 className="text-lg font-bold text-gray-900 leading-tight mt-1">{bundle?.name}</h3>
              <p className="text-xs text-gray-500 mt-2 leading-relaxed bg-gray-50 p-4 rounded-lg border">{bundle?.description || "No description provided."}</p>
            </div>

            <div className="border-t pt-4 space-y-3">
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-400 font-bold uppercase text-[10px]">Review Cycle:</span>
                <span className="font-extrabold text-gray-800">
                  {formatCycleDisplay(bundle?.reviewCycle)}
                </span>
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-400 font-bold uppercase text-[10px]">Division:</span>
                <span className="font-extrabold text-gray-800 truncate max-w-[150px]">{getOrgName(bundle?.divisionId)}</span>
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-400 font-bold uppercase text-[10px]">Department:</span>
                <span className="font-extrabold text-gray-800 truncate max-w-[150px]">{getOrgName(bundle?.departmentId)}</span>
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-400 font-bold uppercase text-[10px]">Designation:</span>
                <span className="font-extrabold text-gray-800 truncate max-w-[150px]">{getOrgName(bundle?.designationId)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right column: Linked KRAs and Weightage Details */}
        <div className="lg:col-span-2 space-y-4">
          <div className="bg-white rounded-xl p-4 space-y-4">
            <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wider border-b pb-2">Linked Goal Metrics & Weightage</h4>
            
            <div className="space-y-4">
              {bundle?.kras?.map((k, idx) => (
                <div key={idx} className="bg-gray-50/50 border border-gray-100 rounded-lg p-4 space-y-3 hover:shadow-[0_0_25px_rgba(239,68,68,0.2)] transition-all duration-300">
                  <div className="flex justify-between items-start gap-4">
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <span className="flex h-5 w-5 items-center justify-center rounded bg-gray-200 text-gray-500 font-bold text-[9px]">
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                        <p className="text-xs font-bold text-gray-800 truncate">{k.kraId?.name || k.name || "Custom KRA"}</p>
                      </div>
                      <p className="text-[11px] text-gray-400 leading-relaxed mt-1">{k.kraId?.description || k.description}</p>
                      
                      {/* Targets Layout with unified targetValue added */}
                      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 mt-3 pt-2 border-t border-gray-100 text-[11px]">
                        <div>
                          <span className="text-gray-400 font-bold uppercase text-[8px] block">Review Cycle</span>
                          <span className="text-gray-700 font-semibold">{formatCycleDisplay(k.reviewCycle)}</span>
                        </div>
                        <div>
                          <span className="text-primary font-bold uppercase text-[8px] block">Target Value</span>
                          <span className="text-gray-900 font-bold">{k.targetValue || "N/A"}</span>
                        </div>
                        <div>
                          <span className="text-gray-400 font-bold uppercase text-[8px] block">Monthly Target</span>
                          <span className="text-gray-700 font-semibold">{k.monthlyTarget || "N/A"}</span>
                        </div>
                        <div>
                          <span className="text-gray-400 font-bold uppercase text-[8px] block">Yearly Target</span>
                          <span className="text-gray-700 font-semibold">{k.yearlyTarget || "N/A"}</span>
                        </div>
                      </div>
                    </div>
                    <div className="shrink-0 text-right">
                      <p className="text-xs font-bold text-primary">{k.weightage || 0}%</p>
                      <p className="text-[8px] text-gray-400 font-bold uppercase">Weight</p>
                    </div>
                  </div>

                  <div className="w-full bg-gray-200 h-1.5 rounded-full overflow-hidden">
                    <div className="bg-primary h-full rounded-full" style={{ width: `${k.weightage || 0}%` }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer view actions */}
      <div className="flex justify-between items-center">
        <button onClick={onClose} className="px-5 py-2.5 border border-gray-300 text-gray-600 hover:bg-gray-200 font-bold rounded-lg text-xs uppercase">
          Back to Library
        </button>
        <button onClick={onEdit} className="px-4 py-2.5 bg-primary text-white hover:bg-secondary font-bold rounded-lg text-xs uppercase transition-all">
          Edit Bundle Details
        </button>
      </div>
    </div>
  );
};


// ==========================================
// MAIN COMPONENT: KraLibrary
// ==========================================
export default function KraLibrary() {
  const navigate = useNavigate();
  
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("libView") || "list"; 
  const selectedId = searchParams.get("id"); 

  const [subTab, setSubTab] = useState("individual"); 
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null); 

  const [templates, setTemplates] = useState([]);
  const [bundles, setBundles] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  const prefetchLibraryData = useCallback(async () => {
    setLoading(true);
    try {
      const cacheBuster = Date.now();
      const [templatesRes, bundlesRes] = await Promise.all([
        api.get(`${SummaryApi.getAllKraTemplates?.url || "/api/hr/kras/templates"}?t=${cacheBuster}`),
        api.get(`${SummaryApi.getAllKraBundles?.url || "/api/hr/kras/bundles"}?t=${cacheBuster}`)
      ]);

      if (templatesRes.data.success) setTemplates(templatesRes.data.data || []);
      if (bundlesRes.data.success) setBundles(bundlesRes.data.data || []);
    } catch {
      toast.error("Failed to load KRA Library assets.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    prefetchLibraryData();
  }, [prefetchLibraryData]);

  useEffect(() => {
    if (selectedId && (templates.length > 0 || bundles.length > 0)) {
      const isBundleView = view.includes("bundle");
      const activeDataset = isBundleView ? bundles : templates;
      const item = activeDataset.find(t => t._id === selectedId);
      if (item) {
        setSelectedItem(item);
        setSubTab(isBundleView ? "bundles" : "individual"); 
      }
    } else if (!selectedId) {
      setSelectedItem(null);
    }
  }, [selectedId, templates, bundles, view]);

  const setView = useCallback((newView) => {
    const params = new URLSearchParams(searchParams);
    if (newView === "list") {
      params.delete("libView");
      params.delete("id");
    } else {
      params.set("libView", newView);
      if (!newView.startsWith("edit_") && !newView.startsWith("view_")) {
        params.delete("id");
      }
    }
    setSearchParams(params, { replace: true });
  }, [searchParams, setSearchParams]);

  const handleSave = () => {
    setView("list");
    prefetchLibraryData();
  };

  const filteredData = React.useMemo(() => {
    const activeDataset = subTab === "individual" ? templates : bundles;
    return activeDataset.filter(item => {
      if (searchTerm) {
        const searchLower = searchTerm.toLowerCase();
        if (!item.name?.toLowerCase().includes(searchLower) && !item.kraId?.toLowerCase().includes(searchLower)) return false;
      }
      if (subTab === "individual" && categoryFilter && item.category !== categoryFilter) return false;
      if (statusFilter && item.status !== (statusFilter === "active" ? "ACTIVE" : "DRAFT")) return false;
      return true;
    });
  }, [subTab, templates, bundles, searchTerm, categoryFilter, statusFilter]);

  const paginatedData = React.useMemo(() => {
    if (itemsPerPage === "All") return filteredData;
    const start = (currentPage - 1) * Number(itemsPerPage);
    return filteredData.slice(start, start + Number(itemsPerPage));
  }, [filteredData, currentPage, itemsPerPage]);

  const handleEdit = (row) => {
    setSelectedItem(row);
    const params = new URLSearchParams(searchParams);
    params.set("libView", subTab === "individual" ? "edit_individual" : "edit_bundle");
    params.set("id", row._id);
    setSearchParams(params, { replace: true });
  };

  const handleView = (row) => {
    setSelectedItem(row);
    const params = new URLSearchParams(searchParams);
    params.set("libView", subTab === "individual" ? "view_individual" : "view_bundle");
    params.set("id", row._id);
    setSearchParams(params, { replace: true });
  };

  const handleDeleteClick = (row) => {
    setItemToDelete(row);
    setDeleteError(null);
    setIsDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;
    setIsDeleting(true);
    setDeleteError(null);
    try {
      const endpoint = subTab === "individual"
        ? SummaryApi.deleteKraTemplate?.url(itemToDelete._id)
        : SummaryApi.deleteKraBundle?.url(itemToDelete._id);

      await api.delete(endpoint);
      toast.success("Successfully deleted item.");
      
      if (subTab === "individual") {
        setTemplates(p => p.filter(t => t._id !== itemToDelete._id));
      } else {
        setBundles(p => p.filter(b => b._id !== itemToDelete._id));
      }
      setIsDeleteOpen(false);
      setItemToDelete(null);
    } catch (err) {
      const errMsg = err.response?.data?.message || "Deletion failed.";
      setDeleteError({ message: errMsg, users: [] });
      toast.error(errMsg);
    } finally {
      setIsDeleting(false);
    }
  };

  const tableActions = [
    { label: "View Details", icon: <Eye className="h-4 w-4" />, onClick: (row) => handleView(row) },
    { label: "Edit Item", icon: <Edit2 className="h-4 w-4" />, onClick: (row) => handleEdit(row) },
    { label: "Delete Item", icon: <Trash2 className="h-4 w-4" />, onClick: (row) => handleDeleteClick(row) }
  ];

  if (view === "create_wizard") {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 text-center space-y-8 animate-in fade-in duration-300">
        <div className="flex justify-between items-center border-b pb-4">
          <h3 className="font-bold text-gray-900 text-lg md:text-2xl">Choose Creation Type</h3>
          <button onClick={() => setView("list")} className="text-gray-400 hover:text-primary transition-transform duration-300 hover:rotate-180 font-bold"><X/></button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4">
          <div className="bg-white border-2 border-gray-100 hover:border-primary rounded-lg p-8 text-center flex flex-col justify-between items-center transition-all hover:shadow-lg group">
            <div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center mb-6 text-primary transition-all group-hover:bg-red-100"><Library className="w-8 h-8" /></div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Individual KRA</h3>
            <p className="text-xs text-gray-400 max-w-xs mb-6">Create one KRA for future allocation. Best for specific, unique performance metrics.</p>
            <button onClick={() => { setSelectedItem(null); setView("create_individual"); }} className="bg-primary hover:bg-secondary text-white font-bold text-sm px-8 py-2.5 rounded-lg transition-all">Select</button>
          </div>
          <div className="bg-white border-2 border-gray-100 hover:border-primary rounded-lg p-8 text-center flex flex-col justify-between items-center transition-all hover:shadow-lg group">
            <div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center mb-6 text-primary transition-all group-hover:bg-red-100"><Layers className="w-8 h-8" /></div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Bundle KRA</h3>
            <p className="text-xs text-gray-400 max-w-xs mb-6">Create multiple KRAs together as one reusable bundle. Perfect for standardized roles.</p>
            <button onClick={() => { setSelectedItem(null); setView("create_bundle"); }} className="bg-primary hover:bg-secondary text-white font-bold text-sm px-8 py-2.5 rounded-lg transition-all">Select</button>
          </div>
        </div>
      </div>
    );
  }

  if (view === "create_individual" || view === "edit_individual") {
    return (
      <IndividualKraForm 
        kra={selectedItem} 
        kraId={selectedId}
        onClose={() => setView("list")} 
        onSave={handleSave} 
        onBackToWizard={() => setView("create_wizard")}
      />
    );
  }

  if (view === "create_bundle" || view === "edit_bundle") {
    return (
      <BundleKraForm 
        bundle={selectedItem} 
        bundleId={selectedId}
        onClose={() => setView("list")} 
        onSave={handleSave} 
        onBackToWizard={() => setView("create_wizard")}
      />
    );
  }

  if (view === "view_individual") {
    return (
      <IndividualKraView 
        kra={selectedItem} 
        onClose={() => setView("list")} 
        onEdit={() => setView("edit_individual")}
        onBackToWizard={() => setView("create_wizard")} 
      />
    );
  }

  if (view === "view_bundle") {
    return (
      <BundleKraView 
        bundle={selectedItem} 
        onClose={() => setView("list")} 
        onEdit={() => setView("edit_bundle")} 
        onBackToWizard={() => setView("create_wizard")}
      />
    );
  }

  return (
    <div className="">
    <div className="space-y-6">
      <PageHeader
        title="Key Result Areas"
        description="Manage and allocate organization-wide performance benchmarks."
        isSticky={true}
        topOffset="top-[51px]"
        onBack={() => navigate(-1)}
        action={{
          label: "Create New KRA",
          icon: Plus,
          onClick: () => setView("create_wizard"),
        }}
      />

      <div className="flex gap-2 pb-px">
        <button onClick={() => { setSubTab("individual"); setCurrentPage(1); }} className={`pb-2.5 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${subTab === "individual" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"}`}>
          Individual Templates ({templates.length})
        </button>
        <button onClick={() => { setSubTab("bundles"); setCurrentPage(1); }} className={`pb-2.5 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${subTab === "bundles" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"}`}>
          KRA Bundles ({bundles.length})
        </button>
      </div>

      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input type="text" placeholder={`Search ${subTab === "individual" ? "individual templates" : "KRA bundles"}...`} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 outline-none text-sm" />
          </div>
          <button onClick={() => setShowFilters(!showFilters)} className={`flex items-center gap-2 px-4 py-2 border rounded-lg text-sm transition-colors ${showFilters ? 'bg-red-50 border-red-300 text-red-700 font-semibold' : 'bg-white border-gray-300'}`}>
            <Filter className="h-5 w-5" /> Filters
          </button>
        </div>

        {showFilters && (
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 animate-in fade-in slide-in-from-top-2">
            <SelectDropdown label="Status" options={[{ label: 'All Status', value: '' }, { label: 'Active', value: 'active' }, { label: 'Draft', value: 'inactive' }]} value={statusFilter} onChange={setStatusFilter} valueKey="value" labelKey="label" searchable={true} />
            <button onClick={() => { setCategoryFilter(''); setStatusFilter(''); setSearchTerm(''); }} className="text-primary text-sm font-medium flex items-center gap-1 hover:underline">
              <X className="h-4 w-4" /> Clear All Filters
            </button>
          </div>
        )}
      </div>

      {loading ? (
        <PageLoader />
      ) : filteredData.length === 0 ? (
        <div className="bg-white rounded-xl border p-12 text-center mt-4">
          <Library className="h-12 w-12 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900">No records found</h3>
          <p className="text-gray-500">Try adjusting your filters or search keywords.</p>
        </div>
      ) : (
        <ModernTable
          columns={subTab === "individual" ? [
            { label: "KRA Code", key: "kraId", render: (row) => <span className="font-mono font-bold text-gray-500">{row.kraId || "KRA-TMP"}</span> },
            { label: "Goal Benchmark Details", key: "name", render: (row) => <div><p className="font-bold text-gray-900">{row.name}</p><p className="text-[11px] text-gray-400 truncate max-w-xs">{row.description}</p></div> },
            { label: "Category", key: "category", render: (row) => <span className="bg-red-50 text-primary border border-red-100 px-2.5 py-0.5 rounded-full font-bold text-[10px] uppercase">{row.category || "General"}</span> },
            { label: "Review Cycle", key: "reviewCycle", render: (row) => <span className="font-medium text-gray-600">{formatCycleDisplay(row.reviewCycle)}</span> }, // Formatted display
            { label: "Status", key: "status", render: (row) => <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${row.status === "ACTIVE" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>{row.status || "DRAFT"}</span> }
          ] : [
            { label: "Target Year", key: "year", render: (row) => <span className="font-mono font-bold text-gray-500">{row.year}</span> },
            { label: "Bundle Configuration Name", key: "name", render: (row) => <div><p className="font-bold text-gray-900">{row.name}</p><p className="text-[11px] text-gray-400 truncate max-w-xs">{row.description}</p></div> },
            { label: "Total Goals Linked", key: "kras", render: (row) => <span className="font-bold text-gray-700">{row.kras?.length || 0} items</span> },
            { label: "Review Cycle", key: "reviewCycle", render: (row) => <span className="font-medium text-gray-600">{formatCycleDisplay(row.reviewCycle)}</span> }, // Formatted display
            { label: "Status", key: "status", render: (row) => <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${row.status === "ACTIVE" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>{row.status || "DRAFT"}</span> }
          ]}
          data={paginatedData}
          actions={tableActions}
          selectable={false}
          stickyColumns={1}
          pagination={{
            totalItems: filteredData.length,
            itemsPerPage: itemsPerPage,
            currentPage: currentPage,
            onPageChange: setCurrentPage,
            onItemsPerPageChange: (val) => { setItemsPerPage(val); setCurrentPage(1); }
          }}
        />
      )}

    </div>
      <DeleteConfirmationOffcanvas
        isOpen={isDeleteOpen}
        onClose={() => {
          setIsDeleteOpen(false);
          setItemToDelete(null);
          setDeleteError(null);
        }}
        onConfirm={handleConfirmDelete}
        title={subTab === "individual" ? "Delete KRA Template" : "Delete KRA Bundle"}
        itemName={itemToDelete?.name || ""}
        error={deleteError}
        isLoading={isDeleting}
        deleteType="hard"
        navigateButtonText="Dismiss"
        onNavigateToUsers={() => {
          setIsDeleteOpen(false);
          setItemToDelete(null);
          setDeleteError(null);
        }}
        onViewUser={() => {}}
      />
    </div>
  );
}